import {StyleSheet} from 'react-native';
import {spacing, borderRadius, typography} from '~constants/design';

const createStyles = (colors: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    background: {
      backgroundColor: colors.background,
    },
    scrollViewContainer: {
      paddingBottom: spacing['6xl'],
    },
    headerInsightContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerInsightChip: {
      backgroundColor: colors.primary + '15',
      paddingHorizontal: spacing.sm,
      paddingVertical: 2,
      borderRadius: borderRadius.md,
      marginLeft: spacing.xs,
    },
    headerInsightChipSecondary: {
      backgroundColor: '#FF9500' + '15', // Subtle orange/amber
      paddingHorizontal: spacing.sm,
      paddingVertical: 2,
      borderRadius: borderRadius.md,
      marginLeft: spacing.xs,
    },
    headerInsightText: {
      fontSize: 11,
      color: colors.primary,
      fontWeight: '600',
    },
    headerInsightTextSecondary: {
      fontSize: 11,
      color: '#FF9500',
      fontWeight: '600',
    },
    itemsWrapper: {
      paddingHorizontal: 8,
      marginTop: 8,
    },
    
    // Pyxi Journey Section
    pyxiJourneyTitle: {
      fontSize: typography.fontSize.lg,
      fontWeight: typography.fontWeight.bold,
      color: colors.textPrimary,
      marginBottom: spacing['2xl'],
    },
    journeyItemContainer: {
      backgroundColor: colors.backgroundCard,
      borderRadius: borderRadius.xl,
      paddingVertical: spacing.md,
      paddingHorizontal: spacing.md,
      marginBottom: spacing.md,
    },
    journeyItemRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    journeyIconContainer: {
      width: 48,
      height: 48,
      borderRadius: 24,
      backgroundColor: colors.iconBgColor,
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: spacing.md,
    },
    journeyIconText: {
      fontSize: 20,
    },
    journeyContentContainer: {
      flex: 1,
      paddingRight: 15,
    },
    journeyTitleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    journeyTitleContainer: {
      flex: 1,
    },
    journeyTitle: {
      color: colors.textPrimary,
      fontWeight: typography.fontWeight.bold,
    },
    journeySubtitle: {
      color: colors.primaryDarkText,
      marginTop: 4,
      fontSize: 12,
    },
    journeyProgressRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: spacing.sm,
    },
    journeyProgressContainer: {
      flex: 1,
    },
    journeyProgressBar: {
      height: 6,
      backgroundColor: colors.border + '22',
      borderRadius: 8,
      overflow: 'hidden',
    },
    journeyProgressFill: {
      height: '100%',
      backgroundColor: colors.primary,
    },
    journeyProgressText: {
      color: colors.primaryDarkText,
      marginLeft: spacing.sm,
      fontSize: 12,
    },
    journeyUpdatedContainer: {
      marginTop: spacing.xs,
    },
    journeyUpdatedText: {
      color: colors.primaryDarkText,
      fontSize: 12,
    },
    journeyActionsContainer: {
      alignItems: 'center',
    },
    journeyViewButton: {
      borderWidth: 1,
      borderColor: colors.border,
      paddingVertical: 6,
      paddingHorizontal: 12,
      borderRadius: 8,
      backgroundColor: colors.buttonLightBg,
    },
    journeyViewButtonRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    journeyViewButtonText: {
      color: colors.textPrimary,
      marginLeft: 8,
      fontWeight: 'bold',
      fontSize: 12,
    },
    journeyRetakeButton: {
      marginTop: spacing.sm,
      flexDirection: 'row',
    },
    journeyRetakeButtonText: {
      color: colors.textPrimary,
      marginLeft: 6,
      fontWeight: 'bold',
      fontSize: 12,
    },
    
    // Event Statistics Section
    eventStatsTitle: {
      fontSize: typography.fontSize.lg,
      fontWeight: typography.fontWeight.bold,
      color: colors.textPrimary,
      marginBottom: spacing['2xl'],
    },
    eventStatsTotalContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: spacing.xl,
    },
    eventStatCard: {
      flex: 1,
      backgroundColor: colors.backgroundCard,
      borderRadius: borderRadius.lg,
      paddingVertical: spacing.lg,
      paddingHorizontal: spacing.md,
      marginHorizontal: spacing.sm,
      alignItems: 'center',
      borderWidth: 1,
      borderColor: colors.border + '20',
    },
    eventStatLabel: {
      color: colors.primaryDarkText,
      fontSize: typography.fontSize.sm,
      marginBottom: spacing.sm,
    },
    eventStatValue: {
      color: colors.primary,
      fontSize: typography.fontSize['3xl'],
      fontWeight: typography.fontWeight.bold,
    },
    eventStatsCategoryTitle: {
      fontSize: typography.fontSize.base,
      fontWeight: typography.fontWeight.bold,
      color: colors.textPrimary,
      marginBottom: spacing.md,
      marginTop: spacing.lg,
    },
    eventCategoryRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: spacing.md,
      paddingHorizontal: spacing.sm,
      backgroundColor: colors.backgroundCard + '40',
      borderRadius: borderRadius.lg,
      marginBottom: spacing.sm,
    },
    eventCategoryIconContainer: {
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: colors.iconBgColor,
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: spacing.md,
    },
    eventCategoryIcon: {
      fontSize: 18,
    },
    eventCategoryContent: {
      flex: 1,
    },
    eventCategoryLabel: {
      color: colors.textPrimary,
      fontWeight: typography.fontWeight.bold,
      marginBottom: 4,
    },
    eventCategoryStatsRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    eventCategoryStatText: {
      color: colors.primaryDarkText,
      fontSize: 12,
    },
    eventCategoryStatSeparator: {
      color: colors.primaryDarkText,
      fontSize: 12,
      marginHorizontal: spacing.sm,
    },
    
    // Loading and Empty States
    loadingContainer: {
      paddingVertical: spacing.xl,
      alignItems: 'center',
    },
    loadingText: {
      color: colors.textSecondary,
      fontSize: typography.fontSize.base,
    },
    emptyContainer: {
      paddingVertical: spacing.xl,
      alignItems: 'center',
    },
    emptyText: {
      color: colors.textSecondary,
      fontSize: typography.fontSize.base,
      textAlign: 'center',
    },
    
    // Settings Sections
    settingsContainer: {
      paddingHorizontal: spacing.md,
    },
    sectionTitle: {
      fontSize: typography.fontSize.lg,
      fontWeight: typography.fontWeight.bold,
      color: colors.textPrimary,
      marginBottom: spacing.sm,
      marginTop: spacing.md,
    },
    sectionTitleLarge: {
      fontSize: typography.fontSize.lg,
      fontWeight: typography.fontWeight.bold,
      color: colors.textPrimary,
      marginBottom: spacing.sm,
      marginTop: spacing.lg,
    },
    settingsDivider: {
      height: 1,
      backgroundColor: colors.border + '40',
      marginHorizontal: spacing.lg,
    },
    
    // Version
    versionContainer: {
      alignItems: 'center',
      marginTop: 8,
    },
    versionText: {
      color: colors.gray400,
    },
    cancelSubscriptionButton: {
      marginHorizontal: spacing.md,
      marginTop: spacing.xl,
      marginBottom: spacing.md,
      paddingVertical: spacing.md,
      borderRadius: borderRadius.lg,
      backgroundColor: colors.background,
      borderWidth: 1,
      borderColor: colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
    },
    cancelSubscriptionButtonText: {
      color: colors.primary,
      fontWeight: 'bold',
      fontSize: 14,
    },
  });

export default createStyles;
